module.exports = __webpack_public_path__ + "media/笑声.28ef3beb.wav";